import {
  defaultSystemCode,
  defaultTrader,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  Trader,
  TraderFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface AcceptOrder {
  orderId: number
  bibliographyRealId: number
  collectionNo: string
  publishDate: string
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  orderDate: string
  orderPrice: number
  status: SystemCode
  branchCode: SystemCode
  collectionType: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  acceptType: SystemCode
  shelfType: SystemCode
  traderCode: Trader
  mark: string
  ndc: string
  book: string
  sub: string
  reserveCount: number
  revision: number
}

export function AcceptOrderFromJSON(json: any): AcceptOrder {
  return {
    orderId: exists(json, 'order_id') ? json.order_id : 0,
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    publishDate: exists(json, 'publish_date')
      ? dateToPlainFormat(json.publish_date)
      : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    orderDate: exists(json, 'order_date')
      ? dateToPlainFormat(json.order_date)
      : '',
    orderPrice: exists(json, 'order_price') ? json.order_price : 0,
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    traderCode: exists(json, 'trader_code')
      ? TraderFromJSON(json.trader_code)
      : defaultTrader(),
    mark: exists(json, 'mark') ? json.mark : '',
    ndc: exists(json, 'ndc') ? json.ndc : '',
    book: exists(json, 'book') ? json.book : '',
    sub: exists(json, 'sub') ? json.sub : '',
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
